var map = {
	"./demo-admin.json": "a4ad",
	"./demo-count-1.json": "6641",
	"./demo-count-2.json": "11ed",
	"./demo-count-3.json": "f840",
	"./demo-count-4.json": "da78",
	"./demo-count-5.json": "152f",
	"./demo-count.json": "8015",
	"./demo-display.json": "fd4b",
	"./demo-stats.json": "efce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2501";